import * as Yup from 'yup';

import { EMainPageAdvantageIcons } from '@/shared/types/mainPage';

export const ADVANTAGE_VALIDATION_SCHEMA = Yup.object().shape({
  title: Yup.string().required('Обязательное поле').max(200, 'Превышено допустимое количество символов'),
  description: Yup.string().required('Обязательное поле').max(500, 'Превышено допустимое количество символов'),
  icon: Yup.string()
    .oneOf(Object.values(EMainPageAdvantageIcons))
    .test('required', 'Обязательное поле', (value) => value !== undefined),
});
